// "use client"
// import Image from 'next/image'
// import React, { useEffect, useRef } from 'react'
// import gsap from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

// gsap.registerPlugin(ScrollTrigger)

// const LongBanner = () => {
//   const containerRef = useRef(null)
//   const trackRef = useRef(null)

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       // Track width varies by breakpoint (wider on mobile so each plate is
//       // bigger). Derive the overflow from the actual rendered sizes so the pan
//       // stays correct at every width. Recomputed on refresh via invalidateOnRefresh.
//       const startXPercent = () => {
//         const track = trackRef.current
//         const container = containerRef.current
//         if (!track || !container) return 0
//         const overflow = track.scrollWidth - container.clientWidth
//         return -(overflow / track.scrollWidth) * 100
//       }
//       gsap.fromTo(
//         trackRef.current,
//         { xPercent: startXPercent }, // enter view: shifted left -> shows the LAST plates
//         {
//           xPercent: 0, // scroll through: slides back -> reveals the earlier plates
//           ease: 'none',
//           scrollTrigger: {
//             trigger: containerRef.current,
//             // Start after the banner is comfortably in view and end before it
//             // leaves the top, so the -33.33 / 0 extremes (last & first plate
//             // fully framed) land while the whole banner is on screen.
//             start: 'top 75%',
//             end: 'bottom 30%',
//             scrub: true,
//             invalidateOnRefresh: true
//           }
//         }
//       )
//     }, containerRef)

//     // Sections above load/grow after mount (CMS data, images, fonts), which
//     // shifts the banner down. Recompute the trigger's start/end when that
//     // settles, otherwise the pan maps to a stale scroll range and looks frozen.
//     const refresh = () => ScrollTrigger.refresh()

//     // rAF-debounced so refresh (which can re-layout) never re-enters the
//     // observer synchronously.
//     let raf = 0
//     const scheduleRefresh = () => {
//       cancelAnimationFrame(raf)
//       raf = requestAnimationFrame(refresh)
//     }

//     // One refresh on the next frame after mount. Covers client-side navigation
//     // from another page, where window.load / document.fonts.ready have already
//     // fired (so their handlers never run) and next/image's cached img is already
//     // .complete (so no load event fires) — the exact case where it froze.
//     scheduleRefresh()

//     // The real trigger of the freeze is content ABOVE the banner loading in
//     // after the start/end were computed. Watch the document height and re-map
//     // the pan whenever it changes, which reliably catches both hard refresh
//     // (images streaming in) and SPA navigation (sections mounting/growing).
//     const ro = new ResizeObserver(scheduleRefresh)
//     ro.observe(document.body)

//     window.addEventListener('load', refresh)
//     if (document.fonts?.ready) document.fonts.ready.then(refresh)

//     return () => {
//       window.removeEventListener('load', refresh)
//       cancelAnimationFrame(raf)
//       ro.disconnect()
//       ctx.revert()
//     }
//   }, [])

//   return (
//     <div className='bg-[#FFF8EB]'>
//         <div className="site-container flex flex-col justify-center items-center pb-5">
//             <h2 className='text-primary font-semibold mb-2.5 text-[24px] md:text-[30px] lg:text-[32px]'>Mithas Wahi, Chini Nahi</h2>
//             <p className='text-black max-sm:text-center mb-2.5 text-[16px] md:text-[25px] lg:text-[30px]'>Make all your favorite Indian sweets and desserts completely guilt-free.</p>
//         </div>
//         <div ref={containerRef} className='overflow-hidden'>
//           {/* 6-plate strip. Wider track on small screens => fewer plates in view,
//               so each plate is larger on mobile. 120% on desktop shows ~4 plates. */}
//           <div ref={trackRef} className='w-[300%] sm:w-[200%] md:w-[120%] will-change-transform'>
//             <Image src="/images/long-banner.png" alt='long-banner-image' width={2112} height={341} quality={100} className='w-full h-auto'/>
//           </div>
//         </div>
//     </div>
//   )
// }

// export default LongBanner


"use client"
import Image from 'next/image'
import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const LongBanner = () => {
  const containerRef = useRef(null)
  const trackRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      const startXPercent = () => {
        const track = trackRef.current
        const container = containerRef.current
        if (!track || !container) return 0
        const overflow = track.scrollWidth - container.clientWidth
        return -(overflow / track.scrollWidth) * 100
      }

      gsap.fromTo(
        trackRef.current,
        { xPercent: startXPercent },
        {
          xPercent: 0,
          ease: 'none',
          force3D: true,
          scrollTrigger: {
            trigger: containerRef.current,
            start: 'top bottom',   // starts as soon as the banner enters the viewport
            end: 'bottom top',     // finishes only once it fully exits — the longest possible window without adding height
            scrub: 1,
            invalidateOnRefresh: true
            // no pin — section stays exactly the size it already is
          }
        }
      )
    }, containerRef)

    const refresh = () => ScrollTrigger.refresh()

    let raf = 0
    const scheduleRefresh = () => {
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(refresh)
    }

    scheduleRefresh()

    const ro = new ResizeObserver(scheduleRefresh)
    ro.observe(document.body)
    const stopObserving = setTimeout(() => ro.disconnect(), 4000)

    window.addEventListener('load', refresh)
    if (document.fonts?.ready) document.fonts.ready.then(refresh)

    return () => {
      window.removeEventListener('load', refresh)
      cancelAnimationFrame(raf)
      clearTimeout(stopObserving)
      ro.disconnect()
      ctx.revert()
    }
  }, [])

  return (
    <div className='bg-[#FFF8EB]'>
        <div className="site-container flex flex-col justify-center items-center pb-5">
            <h2 className='text-primary font-semibold mb-2.5 text-[24px] md:text-[30px] lg:text-[32px]'>Mithas Wahi, Chini Nahi</h2>
            <p className='text-black max-sm:text-center mb-2.5 text-[16px] md:text-[25px] lg:text-[30px]'>Make all your favorite Indian sweets and desserts completely guilt-free.</p>
        </div>
        <div ref={containerRef} className='overflow-hidden'>
          <div ref={trackRef} className='w-[300%] sm:w-[200%] md:w-[120%] will-change-transform [transform:translateZ(0)]'>
            <Image src="/images/long-banner.png" alt='long-banner-image' width={2112} height={341} quality={100} className='w-full h-auto'/>
          </div>
        </div>
    </div>
  )
}

export default LongBanner
